import { render, staticRenderFns } from "./DuoOffers.vue?vue&type=template&id=5a7a8e48&"
import script from "./DuoOffers.vue?vue&type=script&lang=js&"
export * from "./DuoOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports